module.exports = __webpack_public_path__ + "static/media/how_to_reg.7e87311c.svg";